<br><br>
<div class="card">
    <ng-container *ngIf="dataOfPhysicalVerMIDone">
        <div class="print border bold">
            <h4 style="display: inline">{{'FIELD_VERIFICATION_DATA'| translate}}:{{dataOfPhysicalVerMIDone.ProgramName}}</h4>
            <h4 style="display: inline;margin-left:20px;">{{'DATE_OF_VERIFIED'| translate}}:{{dataOfPhysicalVerMIDone.JEActionDate}}</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'NAME_OF_VENDOR'| translate}}</th>
                    <th>{{'FARMER_REGISTRATION_NO'| translate}}.</th>
                    <th>{{'DISTRICT'| translate}}</th>
                </tr>
                <tr>
                    <td>{{dataOfPhysicalVerMIDone.VendorName}}</td>
                    <td>{{dataOfPhysicalVerMIDone.AppID}}</td>
                    <td>{{dataOfPhysicalVerMIDone.District}}</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!-- Field Verification data details end -->
    <br><br>

    <!-- Physical Verification details start -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone || dataOfPhysicalVerMIDone?.listDataForPhysicalVer.length>0">
        <div class="print border bold">
            <h4>{{'PHYSICAL_VERIFICATION'| translate}}</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'S_NO'| translate}}.</th>
                    <th>{{'COMPONENT'| translate}}</th>
                    <th>{{'QUANTITY'| translate}}</th>
                    <th>{{'SIZE'| translate}}</th>
                    <th>{{'PRICE'| translate}}</th>
                    <th>{{'SUBSIDY_AMOUNT'| translate}}</th>
                    <th>{{'FARMER_APP_STATUS'| translate}}</th>
                </tr>

                <tr *ngFor="let row of dataOfPhysicalVerMIDone?.listDataForPhysicalVer;let i=index">
                    <td>{{i+1}}</td>
                    <td>{{row.component}}</td>
                    <td>{{row.EstimatedQuantity}}</td>
                    <td>{{row.size}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{dataOfPhysicalVerMIDone.SubsidyToFarmerAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerAppStatus}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>{{'TOTAL'| translate}}</b></td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice}}</td>
                    <td>{{totalSubsidyAmount}}</td>
                    <td></td>
                </tr>

            </table>
        </div>
    </ng-container>
    <!-- Physical Verification details end -->
    <br><br>

    <!-- Vendor BOQ details start -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone || dataOfPhysicalVerMIDone?.listDataForPhysicalVer.length>0">
        <div class="print border bold">
            <h4>{{'VENDOR_BOQ'| translate}}</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'S_NO'| translate}}</th>
                    <th>{{'COMPONENT'| translate}}</th>
                    <th>{{'QUANTITY'| translate}}</th>
                    <th>{{'SIZE'| translate}}</th>
                    <th>{{'PRICE'| translate}}</th>
                    <th>{{'SUBSIDY_AMOUNT'| translate}}</th>
                    <th>{{'FARMER_SHARE'| translate}}</th>
                </tr>
                <tr *ngFor="let row of dataOfPhysicalVerMIDone?.listDataForPhysicalVer;let i=index">
                    <td>{{i+1}}</td>
                    <td>{{row.component}}</td>
                    <td>{{row.EstimatedQuantity}}</td>
                    <td>{{row.size}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{dataOfPhysicalVerMIDone.SubsidyToFarmerAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerShareAmount}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>{{'TOTAL'| translate}}</b></td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice}}</td>
                    <td>{{totalSubsidyAmount}}</td>
                    <td>{{totalFarmerShare}}</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!-- Vendor BOQ details end -->
    <br><br>

    <!--Vendor Estimate details start  -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone || dataOfPhysicalVerMIDone?.listDataForPhysicalVer.length>0">
        <div class="print border bold">
            <h4>{{'VENDOR_ESTIMATE'| translate}}</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'S_NO'| translate}}</th>
                    <th>{{'COMPONENT'| translate}}</th>
                    <th>{{'QUANTITY'| translate}}</th>
                    <th>{{'SIZE'| translate}}</th>
                    <th>{{'PRICE'| translate}}</th>
                    <th>{{'SUBSIDY_AMOUNT'| translate}}</th>
                    <th>{{'FARMER_SHARE'| translate}}</th>
                    <th>{{'FARMER_APP_STATUS'| translate}}</th>
                    <th>{{'FARMER_VENDOR_STATUS'| translate}}</th>
                </tr>
                <tr *ngFor="let row of dataOfPhysicalVerMIDone?.listDataForPhysicalVer;let i=index">
                    <td>{{i+1}}</td>
                    <td>{{row.component}}</td>
                    <td>{{row.EstimatedQuantity}}</td>
                    <td>{{row.size}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{dataOfPhysicalVerMIDone.SubsidyToFarmerAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerShareAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.farmerAppStatus}}</td>
                    <td>{{dataOfPhysicalVerMIDone.farmerVendorStatus}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>{{'TOTAL'| translate}}</b></td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice}}</td>
                    <td>{{totalSubsidyAmount}}</td>
                    <td>{{totalFarmerShare}}</td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
        </div>

    </ng-container>
    <!-- Vendor Estimate details end -->
    <br><br>

    <!--Bill Uploaded By Vendor details start  -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone">
        <div class="print border bold">
            <h4>{{'BILL_UPLOADED'| translate}}</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'VIEW_BILL'| translate}}</th>
                </tr>
                <!-- <tr  *ngFor="let data of dataOfPhysicalVerMIDone">
          <td>{{data.viewBillUpload}}</td>
        </tr> -->
                <tr *ngIf="dataOfPhysicalVerMIDone">
                    <th><a href="{{dataOfPhysicalVerMIDone.VendorBillBoq}}">{{'VIEW'| translate}}</a></th>
                </tr>
            </table>
        </div>
        <br>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'TOTAL_AMOUNT_COMPONENT'| translate}}</th>
                    <th>{{'AMOUNT_FITTING_ACCESSORIES'| translate}}</th>
                    <th>{{'SUB_TOTAL'| translate}}</th>
                    <th>{{'FARMER_SHARE'| translate}}</th>
                    <th>{{'FARMER_SHARE_DEPOSITED'| translate}}</th>
                </tr>
                <tr>
                    <td>{{dataOfPhysicalVerMIDone.PhyVerTotalComponentAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.PhyVerBilledTransportAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.PhyVerTotalComponentAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerShareAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.AmtPaidByFarmer}}</td>
                </tr>
            </table>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>{{'AREA_MI_INSTALLED'| translate}}</th>
                    <th>{{'PLANT_SPACING_IN'| translate}}</th>
                    <th>{{'CROP_NAME'| translate}}</th>
                    <th>{{'REMARKS_BY_JE'| translate}}</th>
                </tr>
                <tr>
                    <td>{{dataOfPhysicalVerMIDone.MIArea}}</td>
                    <td>{{dataOfPhysicalVerMIDone.PlantSpacing}}</td>
                    <td>{{dataOfPhysicalVerMIDone.CropName}}</td>
                    <td>{{dataOfPhysicalVerMIDone.JERemarks}}</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!-- Bill Uploaded By Vendor details start -->
</div>